import { GetterTree } from 'vuex';
import { InvoiceRunsState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<InvoiceRunsState, RootState> = {
  ['getInvoiceRuns']: (state) => state.invoiceRuns,
  ['getInvoiceRunsIsLoading']: (state) => state.invoiceRuns?.isLoading,
  ['getInvoiceRunsTotal']: (state) => state.invoiceRuns?.total,
  ['getInvoiceRunsSearchParams']: (state) => state.invoiceRuns?.searchParams,
};
